import { render, staticRenderFns } from "./MassiveCityImport.vue?vue&type=template&id=6c25b0d4&"
import script from "./MassiveCityImport.vue?vue&type=script&lang=js&"
export * from "./MassiveCityImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports